// Seed data: BCS events (upcoming + past).

export const seedEvents = [
  {
    id: "seed-ev-1",
    slug: "sabha-day-2026",
    title: "Sabha Day 2026",
    description:
      "The annual celebration of The Bombay Catholic Sabha, honouring our units, volunteers and supporters. The day includes the release of the Sabha Day Souvenir, felicitation of outstanding units, and an address by the Archbishop.",
    event_date: "2026-08-15",
    event_time: "4:00 PM onwards",
    venue: "St. Pius X College Auditorium, Goregaon",
    cover_image:
      "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&w=1600&q=70",
    forum_slug: null,
    unit_slug: null,
    gallery: [],
    documents: [{ title: "Sabha Day 2026 Programme (PDF)", file_url: "#" }],
    is_featured: true,
    is_published: true,
  },
  {
    id: "seed-ev-2",
    slug: "civic-awareness-convention",
    title: "Civic Awareness Convention",
    description:
      "A convention on participative governance ahead of the municipal elections, with panel discussions featuring civic activists, journalists and ward officials. Organised by the Socio Civic & Political Forum.",
    event_date: "2026-07-12",
    event_time: "10:00 AM – 1:00 PM",
    venue: "St. Andrew's Auditorium, Bandra West",
    cover_image:
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1600&q=70",
    forum_slug: "socio-civic-political",
    unit_slug: null,
    gallery: [],
    documents: [],
    is_featured: true,
    is_published: true,
  },
  {
    id: "seed-ev-3",
    slug: "green-parish-mela",
    title: "Green Parish Mela",
    description:
      "An exhibition of composting solutions, solar vendors, terrace gardening and zero-waste living for parish communities, hosted by the Environment Forum.",
    event_date: "2026-07-26",
    event_time: "9:00 AM – 5:00 PM",
    venue: "Immaculate Conception Church Grounds, Borivali West",
    cover_image:
      "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=1600&q=70",
    forum_slug: "environment",
    unit_slug: "immaculate-conception-church",
    gallery: [],
    documents: [],
    is_featured: true,
    is_published: true,
  },
  {
    id: "seed-ev-4",
    slug: "upsc-orientation-2026",
    title: "UPSC / MPSC Orientation for Aspirants",
    description:
      "Orientation session for the new academic batch of the BCS civil services academy. Open to youth from all units; parents welcome.",
    event_date: "2026-06-28",
    event_time: "3:00 PM – 6:00 PM",
    venue: "Holy Family Hall, Andheri East",
    cover_image:
      "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1600&q=70",
    forum_slug: "youth-training",
    unit_slug: null,
    gallery: [],
    documents: [{ title: "Academy Prospectus (PDF)", file_url: "#" }],
    is_featured: false,
    is_published: true,
  },
  {
    id: "seed-ev-5",
    slug: "senior-citizens-health-camp",
    title: "Senior Citizens' Health Camp",
    description:
      "Free health check-up camp for senior citizens with general physicians, ophthalmologists and physiotherapists, organised with parish SVP conferences.",
    event_date: "2026-06-21",
    event_time: "8:30 AM – 1:00 PM",
    venue: "St. Michael's School Hall, Mahim",
    cover_image:
      "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=1600&q=70",
    forum_slug: null,
    unit_slug: "st-michael-s-church",
    gallery: [],
    documents: [],
    is_featured: false,
    is_published: true,
  },
  {
    id: "seed-ev-6",
    slug: "voter-registration-drive-2026",
    title: "Deanery-level Voter Registration Drive",
    description:
      "Registration desks at parishes across the Bandra and Andheri deaneries after all Sunday masses. Bring address proof and a passport photo.",
    event_date: "2026-04-12",
    event_time: "After all morning masses",
    venue: "Multiple parishes — Bandra & Andheri deaneries",
    cover_image:
      "https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?auto=format&fit=crop&w=1600&q=70",
    forum_slug: "socio-civic-political",
    unit_slug: null,
    gallery: [
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1200&q=70",
      "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1200&q=70",
    ],
    documents: [],
    is_featured: false,
    is_published: true,
  },
  {
    id: "seed-ev-7",
    slug: "aarey-tree-plantation",
    title: "Aarey Tree Plantation & Clean-up",
    description:
      "Monsoon plantation of 500 native saplings and a clean-up drive at Aarey, continuing the Sabha's long-standing commitment to Mumbai's green lung.",
    event_date: "2025-07-06",
    event_time: "7:00 AM – 11:00 AM",
    venue: "Aarey Colony, Goregaon East",
    cover_image:
      "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1600&q=70",
    forum_slug: "environment",
    unit_slug: null,
    gallery: [
      "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=1200&q=70",
    ],
    documents: [],
    is_featured: false,
    is_published: true,
  },
  {
    id: "seed-ev-8",
    slug: "christmas-outreach-2025",
    title: "Christmas Outreach for Street Families",
    description:
      "Distribution of festive meals, blankets and school kits to street families across South Mumbai, in collaboration with parish youth groups.",
    event_date: "2025-12-20",
    event_time: "5:00 PM onwards",
    venue: "Starting point: Cathedral of the Holy Name, Colaba",
    cover_image:
      "https://images.unsplash.com/photo-1593113598332-cd288d649433?auto=format&fit=crop&w=1600&q=70",
    forum_slug: null,
    unit_slug: "cathedral-of-the-holy-name",
    gallery: [
      "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1200&q=70",
      "https://images.unsplash.com/photo-1593113598332-cd288d649433?auto=format&fit=crop&w=1200&q=70",
    ],
    documents: [],
    is_featured: false,
    is_published: true,
  },
];
